var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 580.39,
    height: 412.273,
    viewBox: "0 0 580.39 412.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-users",
    "data-name": "Icon awesome-users",
    d: "M84.058,170.367a56.039,56.039,0,1,0-56.039-56.039A56.091,56.091,0,0,0,84.058,170.367Zm392.273,0a56.039,56.039,0,1,0-56.039-56.039A56.091,56.091,0,0,0,476.331,170.367Zm28.019,28.019H448.312a55.874,55.874,0,0,0-39.49,16.286,128.078,128.078,0,0,1,65.758,95.792h57.79a27.989,27.989,0,0,0,28.019-28.019v-28.02A56.091,56.091,0,0,0,504.351,198.386Zm-224.156,0a98.068,98.068,0,1,0-98.068-98.068A98.019,98.019,0,0,0,280.195,198.386Zm67.247,28.019h-7.268a135.4,135.4,0,0,1-119.958,0h-7.268a100.9,100.9,0,0,0-100.87,100.87v25.218a42.04,42.04,0,0,0,42.029,42.029H406.282a42.04,42.04,0,0,0,42.029-42.029V327.276A100.9,100.9,0,0,0,347.442,226.406ZM151.568,214.673a55.874,55.874,0,0,0-39.49-16.286H56.039A56.091,56.091,0,0,0,0,254.425v28.02a27.989,27.989,0,0,0,28.019,28.019h57.7A128.4,128.4,0,0,1,151.568,214.673Z",
    transform: "translate(10 7.75)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 20
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.b5c0ce4d3b0f509cfdbc678809a72cd3.svg";
export { ForwardRef as ReactComponent };